import { render, staticRenderFns } from "./AirboxTable.vue?vue&type=template&id=6afd937c"
import script from "./AirboxTable.vue?vue&type=script&lang=js"
export * from "./AirboxTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports